import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import LessonPlanVersionState from "@/modules/lesson-plan-version";
import { AppBreadCrumbModule } from "@/modules/bread-crumb";
import { Paths } from "@/util/paths";
import { BreadCrumbMenuLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";

export const LessonPlanVersionResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const lessonPlanVersionModule = getModule(LessonPlanVersionState);
	const actions: Promise<void>[] = [];
	const appBreadCrumbModule = AppBreadCrumbModule;
	appBreadCrumbModule.setBreadCrumbRoutes([
		{
			path: Paths.LessonPlanVersion,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPV),
			params: {},
			queryParams: {}
		}
	]);
	actions.push(lessonPlanVersionModule.fetchLessonPlanVersions());
	await Promise.all(actions);
	next();
};
